const styles = (theme) => ({
  containerMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  paperComponent: {
    p: 2,
    borderRadius: "16px",
    width: "100%",
    display: "flex",
    gap: 1,
    minHeight: "150px",
    flexDirection: "column",
  },
  boxTypeResposta: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
});
export default styles;
